import { WebGLRenderer } from 'three';

function createRenderer(container) {
  const renderer = new WebGLRenderer({antialias: true, canvas: container});

  return renderer;
}

export { createRenderer };